import { DDDNormalWinPresentation } from "../normal/DDDNormalWinPresentation";

export class DDDRespinWinPresentation extends DDDNormalWinPresentation {
    constructor(id: string = `DDDRespinWinPresentation`) {
        super(id);
    }
}
